export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_02.22329227.jpg";